/* TRIAL & FLORA — mounts genus medallions (see trial-flora-art.js, loaded in theme.liquid).
   Re-mounts on theme-editor section reloads. */
(function () {
  function mount(root) {
    /* TF_ART is a top-level const in trial-flora-art.js — script-scoped, not on window */
    if (typeof TF_ART === "undefined") return;
    var nodes = root.querySelectorAll("[data-tf-medallion]");
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].innerHTML = TF_ART.medallion(nodes[i].getAttribute("data-tf-medallion") || "hoya");
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      mount(document);
    });
  } else {
    mount(document);
  }

  document.addEventListener("shopify:section:load", function (e) {
    mount(e.target);
  });
})();
